import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-warning-confirmation-dialog',
    templateUrl: './warning-confirmation-dialog.component.html',
    styleUrls: ['./warning-confirmation-dialog.component.scss'],
})
export class WarningConfirmationDialogComponent {
    @Input() modalMessage: string;

    constructor(private ngbActiveModal: NgbActiveModal) {}

    // * modal click for Delete UserType
    modalOkClick() {
        this.ngbActiveModal.close(true);
    }

    // * modal click for Delete UserType
    modalCancelClick() {
        this.ngbActiveModal.close(false);
    }
}
